(function () {
  const BLOCK_SELECTOR = '[data-shipping-times-block]';
  const ZIP_STORAGE_KEY = 'pp_user_zip';
  const POSTAL_CACHE_KEY = 'pp_ip_postal';
  const POSTAL_CACHE_TS_KEY = 'pp_ip_postal_ts';
  const POSTAL_CACHE_TTL = 21600000;

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Ignore storage errors in privacy-restricted browsers.
    }
  }

  function isValidZip(zip) {
    return zip.trim().length > 0;
  }

  function isUSLike(zip) {
    return /^\d{5}(-\d{4})?$/.test((zip || '').trim());
  }

  async function getPostalFromIP() {
    const cachedPostal = readStorage(POSTAL_CACHE_KEY);
    const cachedAt = Number(readStorage(POSTAL_CACHE_TS_KEY) || 0);

    if (cachedPostal && Date.now() - cachedAt < POSTAL_CACHE_TTL) {
      return cachedPostal;
    }

    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      const postal = data.postal || '';

      if (postal) {
        writeStorage(POSTAL_CACHE_KEY, postal);
        writeStorage(POSTAL_CACHE_TS_KEY, String(Date.now()));
      }

      return postal;
    } catch (error) {
      return '';
    }
  }

  function setZip(block, zip) {
    const zipOutput = block.querySelector('[data-shipping-zip]');

    if (zipOutput) {
      zipOutput.textContent = zip;
    }
  }

  function getZip(block) {
    const zipOutput = block.querySelector('[data-shipping-zip]');
    return zipOutput ? zipOutput.textContent.trim() : '';
  }

  function setExpressVisibility(block, zip) {
    const express = block.querySelector('[data-shipping-express]');
    const cutoff = block.querySelector('[data-shipping-cutoff]');
    const showExpress = isUSLike(zip);

    if (express) {
      express.hidden = !showExpress;
    }

    if (cutoff) {
      cutoff.hidden = true;
    }
  }

  function updateCountdown(block) {
    const now = new Date();
    let cutoff = new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      16,
      0,
      0
    ));

    if (now >= cutoff) {
      cutoff = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        16,
        0,
        0
      ));
    }

    const secondsLeft = Math.floor((cutoff - now) / 1000);
    const zip = getZip(block);
    const countdowns = block.querySelectorAll('[data-shipping-countdown]');
    const cutoffMessage = block.querySelector('[data-shipping-cutoff]');

    if (!zip || secondsLeft <= 0) {
      if (cutoffMessage) {
        cutoffMessage.hidden = !zip;
      }
      return;
    }

    const hours = Math.floor(secondsLeft / 3600);
    const minutes = Math.floor((secondsLeft % 3600) / 60);

    countdowns.forEach((countdown) => {
      countdown.textContent = `${hours}h ${minutes}m`;
    });

    if (cutoffMessage) {
      cutoffMessage.hidden = true;
    }
  }

  function updateStandardDelivery(block) {
    const deliveryOutput = block.querySelector('[data-shipping-standard-date]');
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    const deliveryDate = new Date();
    let daysToAdd = Number(block.dataset.standardOffset || 4);

    if (!deliveryOutput) {
      return;
    }

    while (daysToAdd > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);

      const day = deliveryDate.getDay();
      if (day !== 0 && day !== 6) {
        daysToAdd -= 1;
      }
    }

    deliveryOutput.textContent = deliveryDate.toLocaleDateString('en-US', options);
  }

  function openModal(block) {
    const modal = block.querySelector('[data-shipping-modal]');
    const input = block.querySelector('[data-shipping-input]');
    const error = block.querySelector('[data-shipping-modal-error]');

    if (input) {
      input.value = '';
    }

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    if (modal) {
      modal.hidden = false;
    }

    if (input) {
      input.focus();
    }
  }

  function closeModal(block) {
    const modal = block.querySelector('[data-shipping-modal]');

    if (modal) {
      modal.hidden = true;
    }
  }

  function submitZip(block) {
    const input = block.querySelector('[data-shipping-input]');
    const error = block.querySelector('[data-shipping-modal-error]');
    const inlineError = block.querySelector('[data-shipping-inline-error]');
    const zip = input ? input.value.trim() : '';

    if (!isValidZip(zip)) {
      if (error) {
        error.textContent = 'Please enter a ZIP/postal code';
        error.hidden = false;
      }
      return;
    }

    writeStorage(ZIP_STORAGE_KEY, zip);
    setZip(block, zip);
    setExpressVisibility(block, zip);
    updateCountdown(block);
    closeModal(block);

    if (inlineError) {
      inlineError.style.display = 'none';
    }
  }

  async function hydrateZip(block) {
    const savedZip = readStorage(ZIP_STORAGE_KEY).trim();

    if (savedZip) {
      setZip(block, savedZip);
      setExpressVisibility(block, savedZip);
      updateCountdown(block);
      return;
    }

    const postal = await getPostalFromIP();

    if (postal && isValidZip(postal)) {
      writeStorage(ZIP_STORAGE_KEY, postal);
      setZip(block, postal);
      setExpressVisibility(block, postal);
      updateCountdown(block);
    } else {
      setExpressVisibility(block, '');
    }
  }

  function initBlock(block) {
    if (block.dataset.shippingTimesInitialized === 'true') {
      return;
    }

    block.dataset.shippingTimesInitialized = 'true';

    const editButton = block.querySelector('[data-shipping-edit]');
    const submitButton = block.querySelector('[data-shipping-submit]');
    const input = block.querySelector('[data-shipping-input]');
    const modal = block.querySelector('[data-shipping-modal]');

    updateStandardDelivery(block);
    setExpressVisibility(block, '');
    updateCountdown(block);
    hydrateZip(block);

    window.setInterval(() => updateCountdown(block), 60000);

    if (editButton) {
      editButton.addEventListener('click', () => openModal(block));
    }

    if (submitButton) {
      submitButton.addEventListener('click', () => submitZip(block));
    }

    if (input) {
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          submitZip(block);
        }
      });
    }

    if (modal) {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal(block);
        }
      });
    }
  }

  function initShippingTimesBlocks(container) {
    const scope = container || document;
    scope.querySelectorAll(BLOCK_SELECTOR).forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initShippingTimesBlocks(document));
  } else {
    initShippingTimesBlocks(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initShippingTimesBlocks(event.target);
  });
})();
